// frontend/src/components/Requisitions/edit/components/SelectField.jsx

import React, { useMemo } from "react";

export default function SelectField({
  label,
  value,
  onChange,
  options,
  getId,
  getLabel,
  placeholder,
  extraOption = null,
  disabled = false,
}) {
  const mergedOptions = useMemo(() => {
    const base = Array.isArray(options) ? options : [];

    if (!extraOption) return base;

    const exists = base.some(
      (opt) => String(getId(opt)) === String(getId(extraOption))
    );

    return exists ? base : [extraOption, ...base];
  }, [options, extraOption, getId]);

  return (
    <div>
      <label className="block text-xs font-medium text-gray-700 mb-1">
        {label}
      </label>

      <select
        className={`w-full border rounded px-2 py-1 ${disabled ? "bg-gray-100 text-gray-700 cursor-not-allowed" : ""}`}
        value={value}
        disabled={disabled}
        onChange={(e) => onChange(e.target.value)}
      >
        <option value="">{`— ${placeholder} —`}</option>

        {mergedOptions.map((opt) => {
          const id = getId(opt);
          const text = getLabel(opt);

          return (
            <option key={id} value={id}>
              {text}
            </option>
          );
        })}
      </select>
    </div>
  );
}
